"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizeToRem = void 0;
var REM_TO_PX = 0.0625;
var GRID_SIZE = 8;

var sizeToRem = function sizeToRem(size) {
  return "".concat(size * GRID_SIZE * REM_TO_PX, "rem");
};

exports.sizeToRem = sizeToRem;